import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PointExchangeAPI from "apiConfig/PointExchangeAPI";
import { Status } from "../../../../../redux/constant";

const initialState = {
  data: null,
  status: Status.INITIAL,
  errorMessage: null,
};

export const fetchAsyncUnlinkAccount = createAsyncThunk(
  "accountSetting/fetchAsyncUnlinkAccount",
  async ({ providerName }, { rejectWithValue }) => {
    try {
      const response = await PointExchangeAPI.delete(
        `/linked-accounts/${providerName}`,
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const UnlinkedAccountSlice = createSlice({
  name: "unlinkedAccount",
  initialState,
  reducers: {
    resetUnlinkedAccount: state => {
      state.data = null;
      state.status = Status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAsyncUnlinkAccount.pending, state => {
        state.errorMessage = null;
        state.status = Status.LOADING;
      })
      .addCase(fetchAsyncUnlinkAccount.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.status = Status.LOADED;
      })
      .addCase(fetchAsyncUnlinkAccount.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = Status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = Status.ERROR;
      });
  },
});

export const { resetUnlinkedAccount } = UnlinkedAccountSlice.actions;
export default UnlinkedAccountSlice.reducer;
